import React from "react";
import "./DotLoader.scss";
const DotLoader = ({ text }) => {
  return <div id="loading-dots">{text}</div>;
};

export default DotLoader;
